<template>
  <div>
    <SideBar v-if="sidebarVisible" />

    <router-view v-if="isCurrentRouteWithoutReload" />
    <router-view v-else :key="$route.fullPath" />
  </div>
</template>

<script lang="ts">
import mixins from 'vue-typed-mixins';

import { LayoutEnum } from '@/bundles/App/enums';
import { routesWithoutReload } from '@/bundles/App/consts/routesWithoutReload';
import { AccountLayoutMixin } from '@/bundles/App/mixins/accountMixin';
import { UserAccountsMixin } from '@/bundles/App/mixins/userAccountsMixin';

import SideBar from '@/bundles/App/components/SideBar.vue';

export default mixins(AccountLayoutMixin, UserAccountsMixin).extend({
  name: 'AccountLayout',

  components: { SideBar },

  computed: {
    // Nearest match wins, so a layout can be declared on a whole branch or on a single route.
    sidebarVisible (): boolean {
      const record = [...this.$route.matched].reverse().find(({ meta }) => meta.layout);

      return (record?.meta.layout ?? LayoutEnum.Default) !== LayoutEnum.Blank;
    },

    isCurrentRouteWithoutReload (): boolean {
      return routesWithoutReload.includes(this.$route.name as string);
    },
  },

  watch: {
    '$route.params.accountId': {
      handler (newVal, prevVal) {
        if (isNaN(newVal) || newVal === prevVal) {
          return;
        }

        const isAllowReLogin = this.accounts.some(account => account.id === +newVal);

        if (!isAllowReLogin) {
          this.$router.push(this.getAccountRoute({
            name: 'no-access',
            query: { id: newVal }
          }));
          return;
        }

        if (this.activeAccount?.id !== +newVal) {
          this.reLogin(newVal);
        }
      },
      immediate: true
    }
  },

  methods: {
    async reLogin (id) {
      try {
        this.toggleScreen(true);
        await this.accountLogin({ account: +id });
        this.resetFilters();

        await this.$router.push(this.getAccountRoute({
          name: this.$route.name as string,
          params: this.$route.params,
          query: this.$route.query,
        }));

        if (this.isMultipleAccountAuth) {
          this.clearTemporary();
        }

        window.location.reload(); // added for reload all calls which is needed on first load app
      } catch (error) {
        this.addNotification(error);
      }
    }
  }
});
</script>
